module.exports = __webpack_public_path__ + "static/media/Scotiabank.7802150b.png";